import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Required")
    .trim(),
  password: Yup.string()
    .min(6, "Password is too short - should be 8 chars minimum.")
    .required("Required")
    .max(20, "Password is too long - should be 20 chars maximum.")
    .matches(/^\S*$/, "Whitespace is not allowed"),
});

export const registerSchema = Yup.object().shape({
  fullName: Yup.string()
    .min(3, "Name is too short - should be 3 chars minimum.")
    .required("Required")
    .max(20, "Name is too long - should be 20 chars maximum."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Required")
    .trim(),
  password: Yup.string()
    .min(6, "Password is too short - should be 8 chars minimum.")
    .required("Required")
    .max(20, "Password is too long - should be 20 chars maximum.")
    .matches(/^\S*$/, "Whitespace is not allowed"),
  phone: Yup.string().min(10, "Invalid phone number").required("Required"),
});

export const updateProfileSchema = Yup.object().shape({
  fullName: Yup.string()
    .min(3, "Name is too short - should be 3 chars minimum.")
    .required("Required")
    .max(20, "Name is too long - should be 20 chars maximum."),
  email: Yup.string()
    .email("Invalid email address")
    .required("Required")
    .trim(),
  phone: Yup.string().min(10, "Invalid phone number").required("Required"),
});

// change password
export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .min(3, "Password is too short - should be 3 chars minimum.")
    .required("Required")
    .max(20, "Password is too long - should be 20 chars maximum.")
    .trim("Password must not contain spaces"),
  newPassword: Yup.string()
    .min(3, "Password is too short - should be 3 chars minimum.")
    .required("Required")
    .max(20, "Password is too long - should be 20 chars maximum.")
    .trim("Password must not contain spaces"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
});
